import { useTypedSelector } from "../../stores/hooks";
import { ColumnSortState } from "../../stores/slices/columnSortSlice";

export const useColumnSortState = <Key extends keyof ColumnSortState>(
  table: Key
): ColumnSortState[Key] => {
  const state = useTypedSelector((state) => state.columnSort[table]);
  return state;
};
